module.exports = wp.i18n